export const titleName = {
  cars: 'Cars',
  'bikes-scooters': 'Bikes & Scooters',
  'commercial-vehicles': 'Commercial Vehicles',
  'spare-parts-accessories': 'Accessories'
};

export const subcatIdMap = {
  // under 60
  cars: '71',
  'bikes-scooters': '72',
  'commercial-vehicles': '139',
  'spare-parts-accessories': '74',
  // under 269
  'mobile-phones': '149',
  tablets: '280',
  accessories: '212',
  wearables: '367',
  // under 246
  'pets-clinic': '254',
  'pet-foods': '252',
  'pet-care-accessories': '152',
  'pet-training': '253',
  'pet-shop': '639',
  //under 161
  brides: '162',
  grooms: '163',
  'wedding-planners': '224',
  // under 1
  announcements: '10',
  'charity-donate-ngo': '12',
  'car-pool': '110',
  'lost-found': '120',
  'tender-notice': '237',
  // under 281
  'event-management': '318',
  'live-events': '319',
  // under 194
  'career-counseling': '195',
  'certifications-training': '321',
  'competitive-exams-coaching': '317',
  'distance-learning-courses': '198',
  'entrance-exam-coaching': '316',
  'hobby-classes': '238',
  'play-schools-creche': '242',
  'schools-school-tuitions': '315',
  'study-abroad-consultants': '311',
  'text-books-study-material': '255',
  'vocational-skill-training': '320',
  workshops: '241',
  // under 179
  'acting-modeling-roles': '244',
  'acting-schools': '191',
  'actor-model-portfolios': '245',
  'art-directors-editors': '184',
  'fashion-designers-stylists': '187',
  'make-up-hair-films-tv': '188',
  'modeling-agencies': '182',
  musicians: '192',
  'other-entertainment': '193',
  'photographers-cameraman': '189',
  'script-writers': '183',
  'set-designers': '185',
  'sound-engineers': '186',
  'studios-locations-for-hire': '190',
  //under 40
  'home-office-furniture': '56',
  'home-decor-furnishings': '171',
  household: '54',
  kitchenware: '313',
  'antiques-handicrafts': '146',
  paintings: '206',
  'sport-fitness-equipment': '53',
  bicycle: '347',
  'books-magazines': '52',
  'musical-instruments': '148',
  'coins-stamps': '204',
  collectibles: '169',
  'music-movies': '55',
  'clothing-garments': '145',
  watches: '202',
  jewellery: '168',
  'bags-luggage': '207',
  footwear: '314',
  'fashion-accessories': '203',
  'health-beauty-products': '210',
  'gifts-stationary': '167',
  'toys-games': '57',
  'baby-infant-products': '170',
  kidslearning: '312',
  'wholesale-bulk': '209',
  'everything-else': '58',
  // under 247
  // Home Appliances
  'refrigerators-fridge': '369',
  'washing-machines': '371',
  'air-conditioners-ac': '111',
  'air-coolers': '111',
  'water-heaters-geysers': '111',
  'ceiling-fans': '111',
  'table-fans': '111',
  'vacuum-cleaners': '111',
  'sewing-machines': '111',
  iron: '111',
  'room-heaters': '111',
  'air-purifiers': '111',
  'home-others': '111',
  // Laptop & Accessories
  laptops: '147',
  'desktops-computers': '147',
  printers: '213',
  routers: '213',
  monitor: '213',
  cpu: '213',
  'external-hard-disks': '213',
  'data-cards': '213',
  ram: '213',
  'usb-drives': '213',
  'graphics-card': '213',
  motherboard: '213',
  keyboards: '213',
  mouses: '213',
  'adapters-power-cables': '213',
  'access-points': '213',
  speakers: '213',
  switches: '213',
  batteries: '213',
  'printer-ink-and-toners': '213',
  'external-dvd-writers': '213',
  'wireless-usb-adapters': '213',
  scanners: '213',
  webcams: '213',
  'network-cards': '213',
  'blank-media': '213',
  'cooling-pads': '213',
  'ethernet-cables': '213',
  headsets: '213',
  headphones: '213',
  // Kitchen Appliances,
  'home-kitchen-appliances': '111',
  'water-purifiers': '111',
  'microwave-ovens': '111',
  'mixer-grinder-juicer': '111',
  'induction-cook-tops': '111',
  'dish-washers': '111',
  'oven-toaster-griller': '111',
  'food-processors': '111',
  'electric-cookers': '111',
  'coffee-makers': '111',
  'sandwich-makers': '111',
  'gas-stove': '111',
  'electric-kettles': '111',
  'pop-up-toasters': '111',
  'hand-blenders': '111',
  'air-fryer': '111',
  'electric-tandoor': '111',
  'roti-makers': '111',
  'water-dispenser': '111',
  // Audio Video and Gaming
  tv: '51',
  'music-systems-home-theatre': '223',
  'video-games-consoles': '205',
  'ipods-mp3-players': '150',
  'dvd-players': '51',
  'set-top-box': '51',
  'digital-slr': '112',
  'digital-point-shoot-cameras': '112',
  'cameras-digicams': '112',
  'camera-accessories': '201',
  'binoculars-telescopes': '112',
  camcorders: '112',
  'film-cameras': '112',
  'inverters-ups-generators': '248',
  'tools-machinery-industrial': '113',
  'everything-else': '58',
  'fax-epabx-office-equipment': '122',
  'security-equipment-products': '211',
  'office-supplies': '214',
  'mobiles-tablets': '269',
  'electronics-appliances': '247',
  'home-lifestyle': '40',
  // under 194
  'distance-learning-courses': '198'
};
